/* Header.tsx */
import * as React from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';

import BannerGoMidiaBH from '../../../../assets/images/landingPage/cor20correta-1920x1533.webp';
import { jarallax, jarallaxVideo } from "jarallax";
import "jarallax/dist/jarallax.css"; // opcional, se quiser est
import { TopHeader } from './topHeader';
import { BannerContainer, BannerImage, OrcamentoButton } from './styles';
import { useEffect, useRef, useState } from 'react';

interface INavBar {
  reference: React.RefObject<HTMLDivElement>;
  title?: string | null;
}

const Header: React.FC<INavBar> = ({ reference, title }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el:any = ref.current;
    if (!el) return;

    // inicializa jarallax no elemento (aceita options)
    jarallax(el, { speed: 0.5 });

    // ativa a extensão de vídeo (se precisar de vídeo)
    // jarallaxVideo é seguro chamar mesmo que você não use video
    if (typeof jarallaxVideo === "function") {
      try { jarallaxVideo(el); } catch (e) { /* ignore */ }
    }

    return () => {
      // destrói quando desmontar
      jarallax(el, "destroy");
    };
  }, []);


  return (
    <Box sx={{ width: '100%', maxWidth: '100vw'}}>
      <BannerContainer ref={ref} className="jarallax">
        <TopHeader reference={reference} title={title} />
        <img className="jarallax-img" src={BannerGoMidiaBH} alt="Banner" />
        <OrcamentoButton
          href="https://api.whatsapp.com/send?phone=553131983024595&text=Ol%C3%A1,%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20BHBus%20M%C3%ADdia%20"
          target='_blank'
        >
          Solicite um orçamento
        </OrcamentoButton>
    </BannerContainer>
      {/* <BannerContainer>
        <TopHeader reference={reference} title={title} />
        <BannerImage parallax={scrollY}  src={BannerGoMidiaBH} />

        <OrcamentoButton href="#contlp" target="_blank">
          Solicite um orçamento
        </OrcamentoButton>
      </BannerContainer> */}
    </Box>
  );
};

export default React.memo(Header);
